import React, {useMemo} from 'react';
import {Dropdown, Form} from 'react-bootstrap';
import {SelectField} from '@/components/forms';
import Button from '@/components/ui/Button';
import {ChartSettings} from 'entities/chart';
import {FormikT} from 'utils/types';
import useStoryboardsData from '@/views/storyboard/hooks/useStoryboardsData';
import i18n from 'i18n';

interface Props {
    chartSettingsFormik: FormikT<ChartSettings>;
}

const ChartMoveChartButton: React.FC<Props> = ({chartSettingsFormik}) => {
    const [rawStoryboards] = useStoryboardsData();
    const storyboardChoices = useMemo(
        () => rawStoryboards.map((obj) => ({
            id: obj.id,
            label: obj.title,
        })),
        [rawStoryboards],
    );

    return (
        <Dropdown align="start">
            <Dropdown.Toggle
                as={Button}
                variant="outline-secondary"
                size="sm"
                className="dropdown-toggle-no-caret"
                data-cy="chart-settings-move-chart-toggle"
            >
                {i18n.t('chart_move_chart.text')}
            </Dropdown.Toggle>
            <Dropdown.Menu className="chart-settings-move-chart-menu p-3">
                <Form.Group className="mb-0" controlId="storyboard">
                    <Form.Label>{i18n.t('jt_storyboard.text')}</Form.Label>
                    <SelectField
                        name="storyboardId"
                        value={storyboardChoices.find(el => el.id === chartSettingsFormik.values.storyboardId) ? {
                            value: chartSettingsFormik.values.storyboardId,
                            label: storyboardChoices.find(el => el.id === chartSettingsFormik.values.storyboardId)?.label || '',
                        } : null}
                        onChange={(v) => chartSettingsFormik.setFieldValue('storyboardId', v?.value || storyboardChoices[0]?.id)}
                        options={storyboardChoices.map((el) => ({
                            value: el.id,
                            label: el.label,
                        }))}
                        isRequired={false}
                        error={chartSettingsFormik.errors.storyboardId}
                        touched={chartSettingsFormik.touched.storyboardId}
                    />
                </Form.Group>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default React.memo(ChartMoveChartButton);
